import {GameStateEnums} from '../../../../../../shared/GameEnums'
import {UIGameMechanic} from '../../UIGameEventController'
import {UIGameManager} from '../../UIGameManager'
import {BeginnerModeConstants, HiddenUIElement, getWaitMSForAction} from '@colonist/game-beginner-mode'
import {BankTransactionLedger, BeginnerModeActionState} from '@colonist/game-state-types'
import {CardEnum} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export class UIGameBeginnerModeCardsHelper implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private _shouldCardsFlyToRobber: boolean = false
    private _cardFlyAnimationWaitMS: number = 500

    private _areCardsBeingDealt: boolean = false

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.BeginnerModeActionUpdated: this.onBeginnerModeActionUpdate(data); break
            case UIGameEventEnums.GivePlayerCardFromTile: this._areCardsBeingDealt = true; break
            case UIGameEventEnums.CardAnimationEnd: this._areCardsBeingDealt = false; break
            default: break
        }
    }

    get shouldCardsFlyToRobber() {
        return this._shouldCardsFlyToRobber
    }

    get cardFlyAnimationWaitMS() {
        return this._cardFlyAnimationWaitMS
    }

    get areCardsBeingDealt() {
        return this._areCardsBeingDealt
    }

    private onBeginnerModeActionUpdate(data: BeginnerModeActionState) {
        const isBankHidden = data.hiddenUIElements.includes(HiddenUIElement.Bank)
        this._shouldCardsFlyToRobber = isBankHidden
        this._cardFlyAnimationWaitMS = getWaitMSForAction(BeginnerModeConstants.BASE_WAIT_MS_FOR_CARD_FLY_ANIMATION, data.actionIndex)
    }

    addPendingCardsToMyCurrentCardEnums(myCurrentCardEnums: CardEnum[], cardsToBeAddedFromTile: BankTransactionLedger[]) {
        const myColor = this.uiGameManager.gameController.myColor
        for(const transaction of cardsToBeAddedFromTile) {
            if(transaction.owner != myColor) continue
            myCurrentCardEnums.push(transaction.card)
        }
        myCurrentCardEnums.sort()
    }
}
